export const ErrorStyles = {
    message: "text-base font-semibold my-1.5",
    helpText: "px-10 text-sm-plus text-center font-light",
    actionBlock: "mt-6 w-max flex justify-center",
    icon: {
        container: "rounded-full p-2 shadow bg-white max-w-fit m-4",
        innerContainer: "rounded-full p-8 bg-iw-shieldErrorShadow max-w-fit"
    }
}